import React from "react"
import tw, { styled } from "twin.macro"

const LargePullquote = ({ quote, ...props }) => (
  <Style
    className="promotion promotion--large-pullquote"
    role="complementary"
    {...props}
  >
    <q>{quote}</q>
  </Style>
)
export default LargePullquote

const Style = styled.blockquote`
  text-align: center;
  margin: 8vh 0 !important;
  font-family: Newzald Bold Italic;
  font-size: 8vw;
  font-weight: normal;
  white-space: nowrap;
  ${tw`text-primary sm:[fontSize:calc(1em + 4vmax)] sm:[margin:8vmin 0]!`}

  q {
    line-height: 1;
  }

  q::before,
  q::after {
    content: none;
  }
`
